import React, {Component} from 'react';
import {Dialog, DialogActions, DialogContent, FormControl, TextField} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/ext-language_tools"
import "ace-builds/webpack-resolver";
import Divider from "@material-ui/core/Divider";
import Confirmation from "../../../Confirmation/Confirmation";
import findByString from "../Utils/getValueByString";
import FieldWrapper from "../FieldWrapper";
import {errorHandler} from "../Utils/errorHandler";
import FieldErrorMessage from "../Utils/errorMessage";
import PropTypes from "prop-types";

class JsonType extends Component {
    constructor(props) {
        super(props);
        this.fieldRef = React.createRef();
        this.state = {
            fieldValue: '',
            initialValue: '',
            error: '',
            isChanged: false,
            isOpen: false,
            openConfirmation: false,
        };
    }

    componentDidMount() {
        this.setValues();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const {values, errors} = this.props;
        const {values: prevValues, errors: prevErrors} = prevProps;
        if (values !== prevValues) {
            this.setValues();
        }
        if(errors !== prevErrors){
            this.setErrors()
        }
    }
    componentDidCatch(error, errorInfo) {
        this.setState({errorComponent: true});
        console.log(error, errorInfo)
    }

    setValues = () => {
        const {values, field: {path}} = this.props;
        try {
            let value = findByString(values, path);
            this.setState({values, initialValue: value ? JSON.stringify(value) : '', fieldValue: value ? JSON.stringify(value) : ''})
        } catch (e) {
            console.log(e)
        }
    };
    setErrors = () => {
        const {errors, field: {path}, containerArrayPath} = this.props;
        let errorField = errorHandler(errors, path, containerArrayPath);
        this.setState({error: errorField})
    };

    onChange = (value) => {
        this.setState({fieldValue: value, isChanged: true})
    };
    onKeyDown = (e) => {
        if(e.key === 'Enter'){
            e.stopPropagation();
            e.preventDefault();
            this.openModal();
        }
        if(e.key === 'F2'){
            e.stopPropagation();
            e.preventDefault();
            this.openModal();
        }
    };

    openModal = () => {
        const {field: {disabled}} = this.props;
        if(!disabled){
            this.setState({isOpen: true})
        }
    };
    closeModal = () => {
        const {isChanged} = this.state;
        if (!isChanged) {
            this.setState(state => ({
                isOpen: false,
                fieldValue: state.initialValue
            }));
            this.fieldRef.current.focus()
        } else {
            this.setState({openConfirmation: true})
        }
    };
    submitClose = () => {
        this.setState(state => ({
            isOpen: false,
            fieldValue: state.initialValue,
            isChanged: false,
            openConfirmation: false,
        }));
        this.fieldRef.current.focus()
    };

    setValue = () => {
        const {fieldValue, isValid} = this.state;
        const {field: {path}, setValue} = this.props;
        if (isValid) {
            setValue(JSON.parse(fieldValue), path);
            this.setState({isOpen: false, isChanged: false, initialValue: fieldValue})
        }
    };
    validate = (e) => {
        if (e.length > 0) {
            this.setState({isValid: false})
        } else {
            this.setState({isValid: true})
        }
    };


    render() {
        const {
            field: {
                disabled,
                path,
                label,
                dropdown,
                required
            },
            field,
            fieldStyles,
            labelStyles,
            showLabel,
            goBack,
            focusNow,
            isMobile
        } = this.props;
        const {
            isOpen,
            fieldValue,
            isValid,
            openConfirmation,
            errorComponent,
            values,
            filterValue,
            changed,
            error
        } = this.state;
        return (
            !errorComponent ? (
            <FieldWrapper
                dropdown={dropdown}
                focusNow={focusNow}
                record={values}
                filterValue={filterValue}
                path={path}
                disabled={disabled}
                changed={changed}
                setValue={this.onChangeFromDropDown}
                setInitialValue={this.setInitialValue}
                fieldRef={this.fieldRef}
                fieldStyles={fieldStyles}
                labelStyles={labelStyles}
                showLabel={showLabel}
                label={label}
                goBack={goBack}
                required={required}
                isMobile={isMobile}
            >
                <JsonEditor
                    open={isOpen}
                    fieldValue={fieldValue}
                    onChange={this.onChange}
                    setValue={this.setValue}
                    closeModal={this.closeModal}
                    validate={this.validate}
                    isValid={isValid}
                />
                <FormControl fullWidth={isMobile ? true : fieldStyles.fullWidth}>
                <TextField
                    inputRef={this.fieldRef}
                    label={isMobile && label}
                    fullWidth={isMobile ? true : fieldStyles.fullWidth}
                    error={error.length > 0}
                    onClick={this.openModal}
                    className={fieldStyles.withoutStyles ? 'horizontal-fields-table' : 'form-dynamic'}
                    onKeyDown={this.onKeyDown}
                    style={{
                        flex: '1 1 auto',
                        display: 'block',
                        outline: '1px',
                        height: !isMobile && 25,
                        paddingTop: !isMobile && 3,
                        paddingLeft: !isMobile && 2
                    }}
                    disabled={disabled}
                    variant={isMobile ? "standard" : "outlined"}
                    autoFocus={field.autofocus}
                    onFocus={() => this.setState({isFocused: true})}
                    value={fieldValue}
                    inputProps={{
                        style: {width: !isMobile && fieldStyles.width, height: fieldStyles.height},
                        className: !fieldStyles.withoutStyles && 'with-styles'
                    }}
                />
                    <FieldErrorMessage message={error}/>
                </FormControl>
                <Confirmation
                    open={openConfirmation}
                    submit={this.submitClose}
                    close={() => this.setState({openConfirmation: false})}
                >
                    <span>The record has been changed, do you want to exit without saving?</span>
                </Confirmation>
            </FieldWrapper>
            ) : (
                <span>Something bad with field</span>
            )
        );
    }

}

JsonType.propTypes = {
    errors: PropTypes.array,
    //the object of field
    field: PropTypes.object.isRequired,
    fieldStyles: PropTypes.object.isRequired,
    labelStyles: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
};

export default JsonType;


const JsonEditor = (props) => {
    return (
        <Dialog open={props.open} onClose={props.closeModal} maxWidth={"md"} fullWidth={true}>
            <DialogContent style={{padding: 0}}>
                <AceEditor
                    style={{width: '100%'}}
                    mode="json"
                    focus
                    theme="github"
                    value={props.fieldValue}
                    onChange={(value, stat) => props.onChange(value, stat)}
                    onValidate={props.validate}
                    name="UNIQUE_ID_OF_DIV"
                    editorProps={{$blockScrolling: true}}
                    setOptions={{
                        enableBasicAutocompletion: true,
                        enableLiveAutocompletion: true,
                        enableSnippets: true,
                        useWorker: !!props.validate
                    }}
                />
            </DialogContent>
            <Divider/>
            <DialogActions>
                <Button disabled={!props.isValid} variant={"contained"} color={"primary"}
                        onClick={props.setValue}>Save</Button>
                <Button variant={"contained"} color={"default"} onClick={props.closeModal}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
};